/**
 * 証券番号の表示編集
 * 「XXXX組△第YYYYYY-Z△号」
 * XXXX：証券番号の前4桁
 * YYYYYY：証券番号の後6桁
 * Z：証券番号のチェックデジット
 * △：半角スペース
 *
 * @param sknNo 証券－番号
 * @param ckdNo 契約番号ＣＫＤ－番号
 * @returns 編集後の証券番号
 */
export function formatSecurityNumberDisplay(sknNo: string | null | undefined, ckdNo: string | null | undefined): string {
  const digits = String(sknNo ?? '').replace(/\D/g, '').padStart(10, '0');
  const prefix = digits.slice(0, 4);
  const suffix = digits.slice(-6);
  const checkDigit = String(ckdNo ?? '');
  return `${prefix}組 第${suffix}-${checkDigit} 号`;
}

/** 証券番号API連携項目 */
export interface SecurityNumberApiParts {
  /** 証券－番号 */
  degiSknNo: string;
  /** 証書番号子－番号 */
  degiShsNoKoNo: string;
  /** 契約番号ＣＫＤ－番号 */
  degiKyNoCkdNo: string;
}

/** 証券番号カードからAPI項目を解決するための入力 */
export interface SecurityNumberSource {
  securityNumber?: string;
  rawSknNo?: string;
  rawShsNoKoNo?: string;
  rawCkdNo?: string;
}

/**
 * カードの生値、または表示文字列からAPI連携用の証券番号項目を解決する。
 *
 * @param source カード情報
 * @returns API連携項目
 */
export function resolveSecurityNumberApiParts(source: SecurityNumberSource): SecurityNumberApiParts {
  if (source.rawSknNo) {
    return {
      degiSknNo: source.rawSknNo,
      degiShsNoKoNo: source.rawShsNoKoNo ?? '',
      degiKyNoCkdNo: source.rawCkdNo ?? '',
    };
  }

  const match = source.securityNumber?.match(/(\d+)組\s第(\d+)-(\d*)\s?号/);
  if (!match) {
    return {
      degiSknNo: '',
      degiShsNoKoNo: '',
      degiKyNoCkdNo: '',
    };
  }

  return {
    degiSknNo: `${match[1]}${match[2]}`,
    degiShsNoKoNo: '',
    degiKyNoCkdNo: match[3],
  };
}
